import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

var runOnEnter = function runOnEnter() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  return function (nextState, replaceState, cb) {
    return Promise.all(handlers.map(function (handler) {
      return new Promise(function (resolve) {
        return handler(nextState, replaceState, resolve);
      });
    })).then(function () {
      return cb();
    }).catch(cb);
  };
};

export default runOnEnter;